<div class="welcome-area">
  <div class="welcome-info-row">
    <img class="avatar-img" src="assets/images/user.png" alt="Avatar" />
    <div class="welcome-info-text">
      <div class="welcome-title">¡Bienvenido!</div>
      <div class="welcome-user">{{ nombre }}</div>
      <!-- <div class="welcome-user">Fecha: {{ fecha }}</div> -->
    </div>
  </div>
</div>